import { Entry, Variable } from '../../types';
import { ParsedEntryValue } from '../formUtils';
import { backendValueToFormValue } from './backendValueToFormValue';

export type ParsedEntry = Record<string, ParsedEntryValue>;

export const parseBackendValues = ({
	variables,
	entry
}: {
	variables: Variable[];
	entry: Entry;
}): ParsedEntry => {
	const variablesByVariableName: Record<string, Variable> = variables.reduce((acc, variable) => {
		acc[variable.variableName] = variable;
		return acc;
	}, {} as Record<string, Variable>);
	const valuesByVariableName: Record<string, ParsedEntryValue> = {};

	Object.entries(entry).forEach(([variableName, value]) => {
		const variable: Variable | undefined = variablesByVariableName[variableName];
		if (variable) {
			valuesByVariableName[variableName] = backendValueToFormValue({
				value,
				variable
			});
		}
	});

	return valuesByVariableName;
};

export const defaultEmptyValueForVariables = (variables: Variable[]) => {
	const result: Record<string, any> = {};
	variables.forEach(variable => {
		result[variable.variableName] = backendValueToFormValue({
			value: null,
			variable
		});
	});

	return result;
};
